import { i18n_config_default } from './chunk-5FPUWZMY.mjs';

// src/helpers/factories/settingsDifferences/diffLockScreenFactory.ts
var LockScreenBasicFieldLabels = /* @__PURE__ */ ((LockScreenBasicFieldLabels2) => {
  LockScreenBasicFieldLabels2["showGiftCardOptionsButton"] = "showGiftCardOptionsButton";
  LockScreenBasicFieldLabels2["announcementTitle"] = "announcementTitle";
  LockScreenBasicFieldLabels2["announcementDescription"] = "announcementDescription";
  return LockScreenBasicFieldLabels2;
})(LockScreenBasicFieldLabels || {});
var LockScreenTabsFieldLabels = /* @__PURE__ */ ((LockScreenTabsFieldLabels2) => {
  LockScreenTabsFieldLabels2["showFreshSheetTab"] = "showFreshSheetTab";
  LockScreenTabsFieldLabels2["showSeatingLayoutTab"] = "showSeatingLayoutTab";
  LockScreenTabsFieldLabels2["showEmployeesTab"] = "showEmployeesTab";
  LockScreenTabsFieldLabels2["showLocationsTab"] = "showLocationsTab";
  return LockScreenTabsFieldLabels2;
})(LockScreenTabsFieldLabels || {});
var FIELD_LABELS = {
  ["showGiftCardOptionsButton" /* showGiftCardOptionsButton */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.basic.general.showGiftCardButton"
  ),
  ["announcementTitle" /* announcementTitle */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.basic.announcement.titleInput.label"
  ),
  ["announcementDescription" /* announcementDescription */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.basic.announcement.descriptionInput.label"
  ),
  ["showFreshSheetTab" /* showFreshSheetTab */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.tabs.tab.showFreshSheetTab"
  ),
  ["showSeatingLayoutTab" /* showSeatingLayoutTab */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.tabs.tab.showSeatingLayoutTab"
  ),
  ["showEmployeesTab" /* showEmployeesTab */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.tabs.tab.showEmployeesTab"
  ),
  ["showLocationsTab" /* showLocationsTab */]: i18n_config_default.t(
    "settingsModule.lockScreenSettings.tabs.tab.showLocationsTab"
  )
};
var diffLockScreenFactory = (differences = []) => {
  if (!differences) {
    return {
      basic: [],
      tabs: []
    };
  }
  const mapCallbackFn = (difference) => {
    const fieldName = difference.path[0];
    return {
      field: fieldName,
      value: difference.rhs,
      label: FIELD_LABELS[fieldName],
      textValue: difference.rhs
    };
  };
  const basicFields = differences.filter((difference) => difference.path[0] in LockScreenBasicFieldLabels).map(mapCallbackFn);
  const tabsFields = differences.filter((difference) => difference.path[0] in LockScreenTabsFieldLabels).map(mapCallbackFn);
  return {
    basic: basicFields,
    tabs: tabsFields
  };
};

export { FIELD_LABELS, LockScreenBasicFieldLabels, LockScreenTabsFieldLabels, diffLockScreenFactory };
